import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import { LabelCheckbox } from '../Checkbox';

// Component
export interface IProps {
    label: string;
    disabled?: boolean;
    fieldState: FieldState<boolean>;
}
function FormStateTextField({ fieldState, label, disabled }: IProps) {
    return (
        <LabelCheckbox
            label={label}
            checked={fieldState.value}
            onChange={(e) => fieldState.onChange(e.target.checked)}
            disabled={disabled}
        />
    );
}

export default observer(FormStateTextField);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FormStateFields/LabelCheckbox.tsx